import { Media } from '@quark/media'
import React, { ComponentPropsWithRef } from 'react'

export interface StrapiImage {
  alternativeText?: string
  mime: string // value: {image|video}/fileExtension,
  url: string
}

type StrapiMediaProps = {
  mediaData?: StrapiImage
  alt?: string
} & Omit<ComponentPropsWithRef<typeof Media>, 'src' | 'type'>

const StrapiMedia = (props: StrapiMediaProps) => {
  const { mediaData, alt, imgProps, ...rest } = props
  const mediaType = mediaData?.mime?.split('/')[0]
  switch (mediaType) {
    case 'image':
      return (
        <Media
          type="image"
          src={mediaData?.url ?? ''}
          imgProps={{ alt: alt ?? mediaData?.alternativeText ?? '', ...imgProps }}
          {...rest}
        />
      )
    case 'video':
      return <Media type="video" src={mediaData?.url ?? ''} {...rest} />
    default:
      return null
  }
}

export default StrapiMedia
